module.exports = __webpack_public_path__ + "static/media/icon_support.f2bacb7e.svg";